import React, { FC, useEffect, useState } from 'react';

import { Box, BoxProps } from '@chakra-ui/react';
import { flatten, map, union } from 'lodash';

import { IconTypes, Modal, StackedHeader } from 'components/index';
import { useAccessBoundary } from 'containers/App/hooks/useAccessBoundary';
import { useEnvironmentOptions } from 'containers/App/hooks/useEnvironmentOptions';
import { getWidgetChartType } from 'containers/Reports/ReportsDashboard/Components/config';
import { ReportWidgetHeader } from 'containers/Reports/ReportsDashboard/Components/ReportWidget/ReportWidgetHeader';
import { availableWidgetMap } from 'containers/Reports/ReportsDashboard/Components/widget';
import { useReportsDashboardWidgetConfigs } from 'containers/Reports/ReportsDashboard/hooks/useReportsDashboardWidgetConfigs';
import { toTitleCase } from 'utils/string';

export interface IReportWidget extends BoxProps {
  onClickRemove?: () => void;
  onClickEdit: () => void;
  currentRecord: Record<string, any>;
  isLoading?: boolean;
  getReportingChartDetails(
    chart: Record<string, any>,
    index: number,
    timeRange: string,
  ): void;
}

export const ReportWidget: FC<IReportWidget> = props => {
  const {
    onClickRemove,
    onClickEdit,
    currentRecord,
    isLoading = false,
    getReportingChartDetails,
    ...rest
  } = props;
  const [accounts, setAccounts] = useState<string[]>([]);
  const { getWidgetConfig } = useReportsDashboardWidgetConfigs();
  const [expandChart, setExpandChart] = useState(false);
  const { environmentId } = useAccessBoundary();
  const { environmentMapping } = useEnvironmentOptions();

  useEffect(() => {
    setAccounts(union(flatten(map(currentRecord?.account_ids, o => o))));
  }, [currentRecord?.account_ids]);

  const renderChart = expanded => {
    return (
      <Box w="full" py={3} pb={8} h="full" {...rest}>
        <ReportWidgetHeader
          expandChart={expanded}
          setExpandChart={setExpandChart}
          {...props}
        />
        <Box w="full" h="full" pos="relative">
          <Box
            as={
              availableWidgetMap[getWidgetChartType(currentRecord?.chart_type)]
            }
            {...getWidgetConfig(currentRecord)}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    );
  };
  return (
    <>
      {renderChart(false)}
      {expandChart && (
        <Box>
          <Modal
            isOpen={expandChart}
            onClose={() => setExpandChart(false)}
            size="6xl"
            header={
              <StackedHeader
                upper={toTitleCase(currentRecord?.name)}
                lower={environmentMapping?.[environmentId!]?.name ?? ''}
                type={IconTypes.MixedChart}
                style={{ p: 1 }}
              />
            }
            body={
              <Box w="full" h={'400px'}>
                <Box h="full">{renderChart(expandChart)}</Box>
              </Box>
            }
            styles={{ body: { overflowY: 'auto' } }}
          />
        </Box>
      )}
    </>
  );
};
